module.exports = __webpack_public_path__ + "img/heytrade.74acb53f.png";